<template>
  <div>
    <section class="hero is-light is-fullheight">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <span v-if="!isAuthenticated" class="navbar-item">
                  <router-link
                    :to="{ name: 'login' }"
                    class="button is-white is-outlined"
                  >
                    <i class="material-icons">person</i>&nbsp; Mi cuenta
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <div class>
                <span>
                  <img
                    :class="selectclass('logo')"
                    src="@/assets/logo2.png"
                    alt="Logo"
                  />
                </span>
              </div>
            </div>
            <div class="column">
              <div class="box" :class="selectclass('boxcontactenos')">
                <h1 class="title has-text-dark is-3">Clima Siete</h1>
                <h2 class="subtitle is-6 has-text-dark">
                  Conoce cómo ven las personas a tu organización. <br />
                  Ingresa tus datos, sigue los pasos y podrás conocer el perfil
                  general de clima de tu empresa.
                </h2>
                <div class="field is-grouped is-grouped-centered">
                  <p class="control">
                    <a class="button is-dark is-large" href="#registrar"
                      >Probar gratis</a
                    >
                  </p>
                </div>
                <div class="field is-grouped is-grouped-centered">
                  <p class="control">
                    <a class="button is-light is-large" href="#nuestromodelo"
                      >Conoce nuestro modelo</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-dark is-fullheight" id="registrar">
      <div class="hero-body">
        <div class="container">
          <div v-show="step === 1">
            <h1 class="title">Primero, escribe tu correo</h1>
            <h2 class="subtitle">
              Te sugerimos que uses la dirección de correo electrónico que usas
              en el trabajo.
            </h2>
            <input
              class="input is-large"
              type="email"
              v-model="user.email"
              placeholder="@ Correo electrónico"
            /><br /><br />
            <button class="button is-large is-light" @click="acceptemail">
              Aceptar
            </button>
            <hr />
            <h2 class="subtitle">
              O puedes ingresar directamente con tu cuenta de google
            </h2>
            <button class="button is-large is-light" @click="loginGoogle()">
              <div class="google-icon-wrapper">
                <img class="google-icon" src="@/assets/googlelogo.svg" />
              </div>
              Continuar con Google
            </button>
          </div>
          <div v-show="step === 2">
            <h1 class="title">Ahora. Crea una contraseña</h1>
            <h2 class="subtitle">
              Con la contraseña y tu correo {{ user.email }}, crearemos una
              cuenta para que inicie el diagnóstico.
            </h2>
            <input
              class="input is-large"
              type="password"
              v-model="user.password"
              placeholder="Contraseña"
            /><br /><br />
            <button class="button is-large is-light" @click="acceptpassword">
              Aceptar
            </button>
            <button class="button is-large is-light" @click="cancel">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-dark is-fullheight" id="nuestromodelo">
      <div class="hero-body">
        <div class="container">
          <center>
            <img src="@/assets/Clima_Siete.jpg" />
          </center>
        </div>
      </div>
    </section>
    <y-Footer></y-Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import yFooter from "@/components/core/Footer.vue";
// import apiServices from "@/services/yungol-services-public";
export default {
  data() {
    return {
      step: 1,
      contacto: {
        name: "",
        empresa: "",
        email: "",
        telefono: "",
      },
      user: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "isMovil"]),
  },
  methods: {
    cancel() {
      this.user = {
        email: "",
        password: "",
      };
      this.step = 1;
    },
    async acceptpassword() {
      if (this.user.password) {
        try {
          const userCredential = await this.$auth.createuser(
            this.user.email,
            this.user.password
          );
          console.log("the userCredential is ", userCredential);
          // 60e4433565e84d094a43d98c
          const userToSave = {
            email: this.user.email,
            uid: userCredential.user.uid,
            companys: {},
            currentCompany: "60e4433565e84d094a43d98c",
            claims: {
              free: true,
            },
          };
          userToSave.companys["60e4433565e84d094a43d98c"] = {
            id: "60e4433565e84d094a43d98c",
          };
          await apiServices.post(`/userfree`, userToSave);
          this.$router.push("clima");
        } catch (error) {
          console.log(error.code, error.message);
        }
      }
    },
    async loginGoogle() {
      try {
      } catch (err) {}
    },
    acceptemail() {
      if (this.user.email) {
        this.step = 2;
      } else {
        this.$store.dispatch("notify", {
          message: "Primero. Escribe tu correo",
          type: "is-info",
          position: "center",
        });
      }
    },
    registroGoogle() {
      this.$store.dispatch("notify", {
        message: "Este es un mensaje de prueba",
        type: "is-link",
      });
      this.$ga.event("landing", "prueba"); // con esto se registran eventos en google analytics
    },
    selectclass(clase) {
      let returned;
      if (this.isMovil) {
        returned = `${clase}-movil`;
      } else {
        returned = clase;
      }
      return returned;
    },
  },
  components: {
    yFooter,
  },
};
</script>

<style>
.hero.is-primary.is-bold {
  background-image: linear-gradient(
    141deg,
    #158980 0%,
    #00d1b2 71%,
    #00e7eb 100%
  );
}
.logo {
  width: 90%;
}
.logo-movil {
  widows: 100%;
}
.flecha {
  position: absolute;
  height: 157px;
  margin-top: 74px;
  margin-left: 273px;
  -webkit-transform: rotate(140deg);
  -moz-transform: rotate(140deg);
  -ms-transform: rotate(140deg);
}
.flecha-movil {
  position: absolute;
  height: 157px;
  margin-top: -7px;
  margin-left: 192px;
  -webkit-transform: rotate(140deg);
  -moz-transform: rotate(140deg);
  -ms-transform: rotate(140deg);
}
.largoflecha {
  height: 157px;
}
.largoflecha-movil {
  height: 65px;
}
.sizeflecha {
  width: 250px;
}
.sizeflecha-movil {
  width: 250px;
  max-width: 162px !important;
}
.manosexpertas {
  font-size: 500%;
  line-height: 0.7;
}
.manosexpertas-movil {
  font-size: 378%;
  line-height: 0.7;
}
.boxcontactenos {
  padding: 35px;
  float: left;
  width: 75%;
  -webkit-box-shadow: 10px -8px 0px 1px #510087;
  -moz-box-shadow: 10px -8px 0px 1px #510087;
  box-shadow: 10px -8px 0px 1px #510087;
}
.boxcontactenos-movil {
  padding: 35px;
  float: left;
  width: 100%;
  -webkit-box-shadow: 6px -6px 0px 1px #510087;
  -moz-box-shadow: 6px -6px 0px 1px #510087;
  box-shadow: 6px -6px 0px 1px #510087;
}
.contador {
  position: absolute;
  width: 300px;
  margin-left: -117px;
  margin-top: 8px;
}
.empresario {
  width: 100%;
}
.empresario-movil {
  width: 62%;
  margin-top: 299px;
  margin-left: 94px;
}
.eresempresario {
  font-size: 630%;
  line-height: 1.1;
}
.eresempresario-movil {
  font-size: 400%;
  line-height: 1;
}
.cuadroempresario {
  position: absolute;
  width: 380px;
  height: 500px;
  background-color: rgb(246, 246, 246);
  border-radius: 40px;
}
.cuadroempresario-movil {
  position: absolute;
  margin-top: -5px;
  margin-left: -5px;
  width: 240px;
  height: 303px;
  background-color: rgb(246, 246, 246);
  border-radius: 15px;
}
.cuadroempresario1 {
  position: absolute;
  margin-top: 30px;
  margin-left: 30px;
  width: 380px;
  height: 500px;
  background-color: #209cee;
  border-radius: 40px;
}
.cuadroempresario1-movil {
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
  width: 240px;
  height: 303px;
  background-color: #209cee;
  border-radius: 15px;
}
.hero.is-blue {
  background-color: #0081c9;
  color: #fff;
}
.diveresempresario {
  position: absolute;
  margin-left: 70px;
  margin-top: 60px;
}
.diveresempresario-movil {
  position: absolute;
  margin-left: 10px;
  margin-top: 10px;
}
.horadeuncambio {
  font-size: 195%;
  line-height: 1.1;
}
.horadeuncambio-movil {
  font-size: 140%;
  line-height: 1.1;
}
.google-icon-wrapper {
  margin-top: 1px;
  margin-left: 1px;
  margin-right: 5px;
  width: 30px;
  height: 30px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/landingclima/Landingclima.vue